import {
  contractMonthYearParse,
  longShortTransform,
  timeParseNoNull,
} from "@/_core/_helpers/_helpers";
import { apiService } from "@/_services";

/**
 * Retrieves hedge data for commodities
 * @param {object} _this: context variables
 */
export function getHedgeDataCommodities(_this) {
  const requestToken = _this.dataLoadToken || 0;
  _this.hedgeCommodities = [];
  _this.commodities_hedge_deleted = [];
  let getPortfolioNumber = [];
  try {
    _this.selectedPortfolios.forEach(function(selectedPortfolio) {
      getPortfolioNumber.push(
        _this.companies[_this.selectedCompany].portfolios[selectedPortfolio.id]
          .pk_idportfolio,
      );
    });
  } catch (error) {
    console.error("Portfolio list error");
  }
  let getCommodityNumber = [];
  try {
    for (var commodity in _this.selectedCommodity) {
      getCommodityNumber.push(
        _this.commoditySpecs.filter(
          (com) =>
            com.fk_idproduct.toUpperCase() ===
            _this.selectedCommodity[commodity].name,
        )[0].pk_idcommodity,
      );
    }
  } catch (error) {
    console.error("Commodity list error");
  }

  let params = {
    method: "GET",
    endpoint: "commodity-hedge",
    content_type: "application/json",
    query_params: {
      format: "json",
      commodity: { id_commodities: getCommodityNumber },
      portfolios: { id_portfolios: getPortfolioNumber },
    },
  };
  apiService
    .getAll(params)
    .then((data) => {
      if (requestToken !== (_this.dataLoadToken || 0)) return;
      data = JSON.parse(JSON.stringify(data));
      data.forEach(function(d) {
        const commodity = _this.commoditySpecs.find(
          (comm) => comm.commodity_name === d.fk_idcommodity.toUpperCase(),
        );
        const centsCurrency =
          commodity.is_cents && commodity.fk_idcurrency === "USD"
            ? "USc"
            : d.commodity_currency;
        d.pk =
          _this.companies[_this.selectedCompany].company_name
            .split(/\s/)
            .reduce((response, word) => (response += word.slice(0, 1)), "") +
          d.pk_idcommodityhedge;
        d.quotation = d.commodity_currency + "/" + d.commodity_unit;
        d.continuation_month =
          d.continuation_month === 0 ? null : d.continuation_month;
        d.contract_month_year = contractMonthYearParse(d.contract_month_year);
        d.trade_date = timeParseNoNull(d.trade_date);
        d.fixing_date = timeParseNoNull(d.fixing_date);
        d.value_date = timeParseNoNull(d.value_date);
        d.premium_value_date = timeParseNoNull(d.premium_value_date);
        d.asian_fixing_start_date = timeParseNoNull(d.asian_fixing_start_date);
        d.hedged_date = timeParseNoNull(d.hedged_date);
        d.sale_date = timeParseNoNull(d.sale_date);
        d.buy_sell = longShortTransform(d.buy_sell.toUpperCase());
        d.derivative = d.derivative.toUpperCase();
        d.settlement_type = d.settlement_type.replace("_", " ").toUpperCase();
        d.fk_id_end_product = d.fk_id_end_product
          ? d.fk_id_end_product
          : d.fk_idcommodity.toUpperCase();
        d.fk_idcommodity = `${d.fk_idcommodity.toUpperCase()} (${centsCurrency}/${
          d.commodity_unit
        })`;
        d.fk_idoptiontype = _this.optionTypes[d.fk_idoptiontype - 1].name;
        d.fk_idcommodity_strategy = d.fk_idcommodity_strategy.toUpperCase();
        d.strategy_position = d.fk_idcommodity_strategy.substr(
          0,
          d.fk_idcommodity_strategy.indexOf(" "),
        );
        d.strategy_name = d.fk_idcommodity_strategy.substr(
          d.fk_idcommodity_strategy.indexOf(" ") + 1,
        );
      });
      _this.hedgeCommodities = data;
      _this.showLoadingComHedge = false;
      _this.dataSavedHedgeCommodities = true;
      _this.saveLegendHedgeCommodities = "Saved:";
      _this.refreshLegendHedgeCommodities = "Synced:";
    })
    .catch(function(error) {
      if (requestToken !== (_this.dataLoadToken || 0)) return;
      _this.showLoadingComHedge = false;
      _this.dataSavedHedgeCommodities = true;
      _this.saveLegendHedgeCommodities = "Saved:";
      _this.refreshLegendHedgeCommodities = "Synced:";
      console.error(error);
    });
}
